import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "playground" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PromptSearch = _resolveComponent("PromptSearch")
  const _component_DatasetSearch = _resolveComponent("DatasetSearch")
  const _component_Button = _resolveComponent("Button")
  const _component_Divider = _resolveComponent("Divider")
  const _component_EditablePrompt = _resolveComponent("EditablePrompt")
  const _component_SplitterPanel = _resolveComponent("SplitterPanel")
  const _component_DatasetView = _resolveComponent("DatasetView")
  const _component_Splitter = _resolveComponent("Splitter")
  const _component_Output = _resolveComponent("Output")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, " Playground ", -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PromptSearch, {
          modelValue: $data.prompt_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.prompt_name) = $event)),
          disabled: $data.executing,
          class: "search"
        }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
        _createVNode(_component_DatasetSearch, {
          modelValue: $data.dataset_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.dataset_name) = $event)),
          disabled: $data.executing,
          class: "search"
        }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
        _createVNode(_component_Button, {
          primary: "",
          small: "",
          class: "execute",
          loading: $data.executing,
          disabled: !$options.can_execute || $data.executing,
          onClick: $options.execute
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Execute ")
          ])),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["loading", "disabled", "onClick"])
      ])
    ]),
    _createVNode(_component_Divider, { m: "0" }),
    _createVNode(_component_Splitter, {
      class: "splitter",
      layout: "vertical",
      unstyled: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SplitterPanel, {
          unstyled: false,
          "min-size": 20,
          size: 80
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Splitter, { unstyled: false }, {
              default: _withCtx(() => [
                _createVNode(_component_SplitterPanel, {
                  class: "splitter-panel",
                  unstyled: false,
                  "min-size": 20,
                  size: 80
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EditablePrompt, {
                      "vread-from": "prompt_data",
                      "onUpdate:prompt_data": $event => (($data.prompt_data) = $event),
                      disabled: $data.executing,
                      class: "splitter-block",
                      "prompt-name": $data.prompt_name
                    }, null, 8 /* PROPS */, ["onUpdate:prompt_data", "disabled", "prompt-name"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_SplitterPanel, {
                  class: "splitter-panel",
                  unstyled: false,
                  "min-size": 20,
                  size: 20
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DatasetView, {
                      "vread-from": "dataset_active",
                      "onUpdate:dataset_active": $event => (($data.dataset_data) = $event),
                      prompt: $data.prompt_data?.prompt,
                      disabled: $data.executing,
                      "dataset-name": $data.dataset_name,
                      class: "splitter-block"
                    }, null, 8 /* PROPS */, ["onUpdate:dataset_active", "prompt", "disabled", "dataset-name"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_SplitterPanel, {
          class: "splitter-panel",
          unstyled: false,
          "min-size": 20,
          size: 20
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Output, {
              class: "splitter-block",
              "prompt-data": $data.prompt_data,
              "dataset-data": $data.dataset_data,
              "output-data": $data.output_data
            }, null, 8 /* PROPS */, ["prompt-data", "dataset-data", "output-data"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ]))
}